// extracted by mini-css-extract-plugin
export var root = "Bo-1";
export var rootContainer = "dV6I";
export var tmCarouselCard = "tm-carousel__card";
export var tmCarouselInner = "tm-carousel__inner";
export var tmCarouselOmnibusButtonWrapper = "tm-carousel__omnibus-button-wrapper";
export var tmCarouselProgressTrack = "tm-carousel__progress-track";
export var tmCarouselReview = "tm-carousel__review";
export var tmCarouselTrack = "tm-carousel__track";
export var tmCarouselWrapper = "tm-carousel-wrapper";
export var tmFerret2 = "tm-ferret2";
export var tmFerret2NavButtonNextIcon = "tm-ferret2__nav-button--next-icon";
export var tmFerret2NavButtonPrevIcon = "tm-ferret2__nav-button--prev-icon";
export var tmFerret2NavButtons = "tm-ferret2__nav-buttons";
export var tmFerret2UpperRow = "tm-ferret2__upper-row";
export var tmGrades = "tm-grades";
export var tmIconVerifiedBadgeActive = "tm-icon__verified-badge--active";